<template>
  <resource-create-wrapper
    :title="item ? $t('resources.footers.duplicate_footer') : $t('resources.footers.new_footer')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['footerForm'].submit()">
    <FooterForm :footer="item" @isDirtyForm="isDirtyForm" ref="footerForm"></FooterForm>
  </resource-create-wrapper>
</template>

<script>
  import FooterForm from "@/components/forms/FooterForm";
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      FooterForm,
      ResourceCreateWrapper,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
